/* Good People —— 滾動揭示。
   Charter: docs/charters/2026-09-30-goodpeople-award-grade-craft.md (D7-D10, A10)

   三條規矩：
   1. 內容永遠不靠這支檔案才看得見。隱藏只發生在 <html class="gp-anim"> 存在時，
      而那個 class 由 theme.liquid 裡的行內閘門加上 —— 閘門會在這支檔案沒有
      成功跑起來的時候把它收回去（見下面的 __gpMotion 旗標）。
   2. prefers-reduced-motion: reduce 直接不啟動（閘門就擋掉了，這裡再擋一次）。
   3. 不引任何動畫庫。IntersectionObserver 是瀏覽器內建的。
*/
(function () {
  'use strict';

  var root = document.documentElement;
  if (!('IntersectionObserver' in window)) { return; }

  /* ── 頁首在捲離主視覺之後要變實心 ──────────────────────────────
     首頁的頁首是透明疊在深色主視覺上、字是白的，而它是**黏住的**
     （父層 .shopify-section-group-header-group 是 position:sticky）。
     捲過主視覺之後，白字就壓在白色內容上 —— 連 logo 都看不見。
     2026-09-30 實測：線上主題與 staging 一模一樣，是既有的 bug。

     這一段**不受 prefers-reduced-motion 影響**，也不掛在 gp-anim 上：
     它是能不能讀的問題，不是裝飾。 */
  function headerState() {
    var hero = document.querySelector('.gp-hero');
    if (!hero) { return; }   // 其他頁型的頁首本來就是實心的
    var header = document.querySelector('.header-wrapper');
    var h = header ? header.getBoundingClientRect().height : 80;
    new IntersectionObserver(function (entries) {
      root.classList.toggle('gp-header-solid', !entries[0].isIntersecting);
    }, { rootMargin: (-Math.round(h)) + 'px 0px 0px 0px', threshold: 0 }).observe(hero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', headerState);
  } else {
    headerState();
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    root.classList.remove('gp-anim');
    return;
  }

  // 告訴閘門「我起來了」，它就不會把 gp-anim 收掉。
  window.__gpMotion = 1;

  // 要揭示的東西。全部用 class 選，不必去改 liquid。
  var SELECTOR = [
    '.gp-sec__head',
    '.gp-split__text',
    '.gp-story__chapter',
    '.gp-authority__item',
    '.gp-band__item',
    '.gp-trust__item',
    '.gp-rail__card',
    '.gp-tile',
    '.gp-card',
    '.gp-voice',
    '.gp-ladder__row',
    '.gp-brands__row',
    '.gp-ing__body',
    '.gp-ing__img',
    '.gp-cbanner__inner > *',
    '.gp-verify__inner > *'
  ].join(',');

  var STAGGER_MS = 70;   // 同一組裡每一個晚一點點，視線才會順著走
  var STAGGER_MAX = 6;   // 超過六個就不再往後疊，否則最後一張要等一秒

  function reveal(el) { el.classList.add('gp-is-in'); }

  function init() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    if (!nodes.length) { root.classList.remove('gp-anim'); return; }

    // 同一個父層底下的順序 = 延遲階數
    var seen = new Map();
    nodes.forEach(function (el) {
      var p = el.parentElement || document.body;
      var i = seen.get(p) || 0;
      seen.set(p, i + 1);
      el.style.setProperty('--gp-i', Math.min(i, STAGGER_MAX));
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) { return; }
        reveal(e.target);
        io.unobserve(e.target);   // 揭示是一次性的，不要來回閃
      });
    }, {
      // 進到視窗下緣再往上 12% 才觸發 —— 貼著邊界觸發會看起來像沒動
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.01
    });

    nodes.forEach(function (el) {
      // 首屏就已經在畫面裡的，直接顯示：它們跟主視覺的入場搶戲沒有好處
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) { reveal(el); } else { io.observe(el); }
    });

    // 保險：不管發生什麼，五秒後所有還沒揭示的一律顯示。
    // 寧可少一個動畫，不可以有一行字永遠看不到。
    setTimeout(function () { nodes.forEach(reveal); }, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
